document.addEventListener('DOMContentLoaded', function () {
  // console.log('common.js loaded')
  // remove no-js class
  document.documentElement.classList.remove('no-js');
});